<template>
  <AssociationPageHeader />
  <CreditCardOffer />
  <HowItWorks />
  <Perks @scroll-to-exclusion-details="handleScrollToPoint" />
  <EarnRate />
  <Exclusions />
</template>

<script setup>
import AssociationPageHeader from './associationPageHeader/AssociationPageHeader';
import CreditCardOffer from './creditCardOffer/creditCardOffer';
import HowItWorks from './howItWorks/HowItWorks';
import Perks from './perks/Perks';
import Exclusions from './exclusions/Exclusions';
import EarnRate from './earnRate/EarnRate';
import scrollToPoint from '../utils/scrollToPointUtil';

defineOptions({ name: 'LoyaltyAssociation' });
const handleScrollToPoint = (data) => scrollToPoint(data);
</script>
